<template>
  <div class="lithiumChartChargeDisTem" style="height: 100%;">

    <div style="margin-bottom: 20px;">
      <p class="blockTitleP" style="display:inline-block; width: 400px;">{{ $t("yhubReport.chargeAndDischargeRecords") }}</p>
      <!--重新计算充放电按钮-->
      <el-button v-if="$store.state.isAdmin" type="primary" style="float: right; margin-top: 12px;" icon="el-icon-edit" size="mini" :title="$t('yhubReport.calculateChargeDischargeExceeded')" @click="toCalculateChargeDischarge" />
    </div>
    <!-- 柱状图 -->
    <div style="width:100%;position: relative;" class="columnLineWarp">
      <div id="chart2" class="chart" style="height:500px;width:100%;" />
      <i class="el-icon-question" :class="$store.state.language" @mouseout="mouseoutQuestion(0,'dischargePop')" @mouseover="mouseoverQuestion(0,'dischargePop')" />
      <p v-show="columnLineNoData" style="text-align: center;line-height: 30px;top: 200px;position: absolute;width: 100%;">{{ $t("yhubReport.Nodata") }}</p>
      <div class="dischargePop">
        <p>{{ $t('yhubReport.dischargeInfo') }}</p>
      </div>
      <!-- 由于打印时，需将图表转换成图片，用组件不太适合 -->
      <!-- <column-line-chart :column-line-data="columnLineData" :column-line-n="columnLineN" :height="columnLineHeight" /> -->
      <!-- <img v-show="isPrint" id="chart3" style="width:100%;height:500px;display:none;"> -->
    </div>
    <!-- Charged Records -->
    <p class="blockTitleP" style="display:inline-block;">{{ $t("yhubReport.Records") }}
      <el-button align="right" style="text-align: center;float:right;" class="filter-item" type="primary" icon="el-icon-data-line" @click="readMore(null)" />
      <el-button align="right" style="text-align: center;float:right;margin-right: 10px;" class="filter-item" type="primary" icon="el-icon-download" @click="downChargeDis" />
    </p>
    <el-table :data="chargedRecordsList" border style="width: auto" fit class="myTable chargedRecordTable" :span-method="objectSpanMethod">
      <el-table-column :label="$t('yhubReport.index')" prop="" align="center">
        <template slot-scope="scope">
          <div>
            <p>{{ scope.row.cycles }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.StartingTime')" prop="startTime" align="center" />
      <el-table-column :label="$t('yhubReport.StartSOC')" prop="startSoc" align="center" />
      <el-table-column :label="$t('yhubReport.EndTime')" prop="endTime" align="center" />
      <el-table-column :label="$t('yhubReport.EndSOC')" prop="endSoc" align="center" />
      <el-table-column :label="$t('yhubReport.ah')" prop="energy" align="center" />
      <el-table-column label="KWH" prop="wh" align="center" />
      <el-table-column :label="$t('yhubReport.StartTemp')" prop="startTemp" align="center" />
      <el-table-column :label="$t('yhubReport.EndTemp')" prop="endTemp" align="center" />
      <el-table-column :label="$t('yhubReport.averageTemp')" prop="avgTemp" align="center" />
      <el-table-column :label="$t('yhubReport.MinVoltage')" prop="minVoltage" align="center" />
      <el-table-column :label="$t('yhubReport.MaxVoltage')" prop="maxVoltage" align="center" />
      <el-table-column :label="$t('yhubReport.ChargType')" prop="chargingTypeZh" align="center" />
      <el-table-column :label="$t('yhubReport.Duration')" prop="chargedTime" align="center" />
      <el-table-column :label="$t('AllDevices.Status')" prop="chargeDisStatu" align="center">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.isChargeing">{{ $t('basicinfo.Charged') }}</p>
            <p v-if="!scope.row.isChargeing">{{ $t('basicinfo.DisCharged') }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.Charts')" prop="action" align="center" width="140px" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="mini" class="el-icon-data-line" @click="readMore(scope.row)" />
            <el-button v-if="!scope.row.isChargeing&&$store.state.isAdmin" type="primary" size="mini" class="" @click="openCountSohPop(scope.row)">SOH</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗--折线图 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="90%">
      <el-form ref="bindDeviceModel" label-position="right">
        <el-form-item>
          <!-- 日期选择器 -->
          <!-- <el-date-picker v-model="selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" /> -->
          <el-date-picker v-model="popStartDate" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.startDate')" />
          <span>{{ $t('AllDevices.to') }}</span>
          <el-date-picker v-model="popEndDate" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.endDate')" />
          <el-button class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="changeSearch" />
          <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel()">Download Raw CSV</el-button>
          <!-- <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel()">Download Report CSV</el-button> -->
        </el-form-item>
      </el-form>
      <el-form ref="bindDeviceModel" v-loading="loading" label-position="right">
        <el-form-item style="position:relative;">
          <p v-if="nodata" style="text-align: center;line-height: 30px;top: 50%;position: absolute;width: 100%;transform: translate(0, -50%);z-index:99;">{{ $t("yhubReport.Nodata") }}</p>
          <line-chart :line-chart-data="lineChartData" :height="lineHeight" />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 下载中 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoadingPop" width="60%" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p>{{ $t('button.Downloading') }}</p>
    </el-dialog>
    <!-- 弹窗--手动计算soh -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowCountSOHPop" width="90%">
      <el-form ref="bindDeviceModel" label-position="right">
        <!-- <el-row :gutter="40" style="margin: 20px 0 0 0;">
          <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;"> -->
        <p class="blockTitleP" style="display:inline-block;padding-left:0;">{{ $t('warningPage.SOH') }}</p>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <!-- <el-date-picker v-model="sohSearchObj.sohStartAndEndtime" :disabled="true" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" /> -->
          <div>
            <el-date-picker v-model="sohSearchObj.sohStartTime" :disabled="true" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.startDate')" />
            <span style="padding: 0 5px;word-break: normal;">{{ $t('AllDevices.to') }}</span>
            <el-date-picker v-model="sohSearchObj.sohEndTime" :disabled="true" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.endDate')" />
          </div>

          <div style="max-width: calc(100% - 360px);display: flex;justify-content: flex-end;align-items: center;">
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.ignoreCharg') }}:</span>
            <el-select v-model="sohSearchObj.ignoreCharge" :placeholder="$t('allDeviceDetail.ignoreCharg')" class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px">
              <el-option v-for="(item,index) in ignoreChargeOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <span style="margin-left:10px;">{{ $t('allDeviceDetail.saveDatabase') }}:</span>
            <el-select v-model="sohSearchObj.updateData" :placeholder="$t('allDeviceDetail.saveDatabase')" class="filter-item" filterable style="width: 15%; padding-left: 10px;padding-right: 10px">
              <el-option v-for="(item,index) in updateDataOptions" :key="index" :label="item.label" :value="item.value" />
            </el-select>
            <el-button align="right" style="text-align: center;float:right;" class="filter-item" type="primary" @click="computedSoh">{{ $t('allDeviceDetail.CalculateSOH') }}</el-button>
          </div>
        </div>
        <el-table v-loading="loadingSoh" :data="sohData" border style="width: auto;margin-top:10px;" fit class="myTable">
          <el-table-column :label="$t('yhubReport.StartingTime')" prop="start_timeZh" align="center" />
          <el-table-column :label="$t('yhubReport.EndTime')" prop="end_timeZh" align="center" />
          <el-table-column :label="$t('allDeviceDetail.dischargeA')" prop="currentUsing" align="center" />
          <el-table-column :label="$t('allDeviceDetail.highCurrent')" prop="current_capacity" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocVolt')" prop="socVolt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.TheorySoc')" prop="soc_ll" align="center" />
          <el-table-column :label="$t('allDeviceDetail.Smoothsoc')" prop="soc_ph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocNotSmooth')" prop="soc_wph" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SocMidway')" prop="soc_zt" align="center" />
          <el-table-column :label="$t('allDeviceDetail.SOHaverage')" prop="soh_avg" align="center" />
          <el-table-column :label="$t('allDeviceDetail.FinallyAH')" prop="theoretical_capacity" align="center" />
        </el-table>
        <!-- </el-col>
        </el-row> -->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { parseTime, handleFloat } from '@/utils'
import { listChargingDischargingBMS, listSohRecord, countSoh, calculateChargeDischargeBms } from '@/api/yhub'
import { listBMSRecor } from '@/api/allDevice'
import echarts from 'echarts'
import { thousandFn } from '@/utils/thousandFn.js'
import { usedTime, getDateAndHour } from '@/utils/updateTime.js'
import lineChart from '@/components/lineChartLithium'
import mqtt from 'mqtt'
import protobuf from 'protobufjs'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'
import { temChangeUnit, temChange, temUnit } from '@/utils/temChange.js'
var myOoptions = {}
client = mqtt.connect(MQTT_SERVICE, myOoptions)
var client
// MQTT--------------end
import apiproto from '@/proto/apiproto'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')
import i18n from '@/i18n'

export default {
  components: {
    lineChart
  },
  filters: {
    handleFloat
  },
  props: {
    listQueryTem: { // 电池状态--详细信息
      type: Object,
      default: () => {}
    },
    mcuId: {
      type: String,
      default: ''
    },
    showAll: {
      type: Boolean,
      default: false
    },
    fullChargeTime: {
      type: Number,
      default: 30
    }
  },
  data() {
    this.apiproto
    this.protobuf
    return {
      columnLineNoData: true,
      chargedRecordsList: [],
      popStartDate: null,
      popEndDate: null,
      isShowPop: false,
      lineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a4: [],
        a5: [],
        a6: []
      },
      lineHeight: '600px',
      lineHeight2: '300px',
      lineDate: [],
      nodata: false,
      loading: false,
      isShowLoadingPop: false,
      isShowCountSOHPop: false,
      sohSearchObj: {
        sohStartTime: null,
        sohEndTime: null,
        ignoreCharge: false,
        updateData: false
      },
      ignoreChargeOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      updateDataOptions: [
        { label: i18n.t('allDeviceDetail.Yes'), value: true },
        { label: i18n.t('allDeviceDetail.no'), value: false }
      ],
      sohData: [],
      loadingSoh: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    listQueryTem: {
      handler(newValue, oldValue) {
        this.listQueryTem = newValue // 把新值赋值给我们的属性数据
        this.initChart2()
      },
      deep: true
    },
    language(newValue, oldValue) {
      this.initChart2()
      this.ignoreChargeOptions[0].label = this.updateDataOptions[0].label = i18n.t('allDeviceDetail.Yes')
      this.ignoreChargeOptions[1].label = this.updateDataOptions[1].label = i18n.t('allDeviceDetail.no')
    }
  },
  mounted() {
    setTimeout(() => {
      this.initChart2()
    }, 50)
    this.$nextTick(() => {
      var isShowDischargePopS = document.querySelectorAll('.dischargePop')
      isShowDischargePopS.forEach(v => {
        v.style.display = 'none'
      })
    })
  },
  created() {

  },
  destroyed: function() {

  },
  methods: {
    // 折线图----start
    initChart2() { // 充放电记录
      var n = []
      var chargeData = []
      var disChargeData = []
      var socData = []
      var dom2 = document.getElementById('chart2')
      var myChart2 = echarts.init(dom2)
      myChart2.showLoading()
      this.dataSize = 0
      this.chargedAh = 0
      console.log('listQueryTem--', this.listQueryTem)
      this.param = {
        endDate: this.listQueryTem.endDate,
        mcuId: this.listQueryTem.mcuId,
        // mcuId: '05d4ff333332534e43213328',
        startDate: this.listQueryTem.startDate,
        showAll: this.showAll
      }

      listChargingDischargingBMS(this.param).then(response => {
        this.chargedRecordsList = JSON.parse(JSON.stringify(response.resultModel))
        this.chargedRecordArr = JSON.parse(JSON.stringify(response.resultModel))
        for (var i = this.chargedRecordsList.length - 1; i >= 0; i--) {
          var v = this.chargedRecordsList[i]
          if (!v.startWh || v.startWh < 0)v.startWh = 0
          if (!v.endWh || v.endWh < 0)v.endWh = 0
          v.wh = v.endWh - v.startWh > 0 ? handleFloat((v.endWh - v.startWh) / 1000) : 0
          v.startSoc = Math.round(v.startSoc) + '%'
          v.endSoc = Math.round(v.endSoc) + '%'
          v.startTemp = (v.startTemp || v.startTemp == 0) ? temChangeUnit(Math.round(v.startTemp / 100)) : '--'
          v.endTemp = (v.endTemp || v.endTemp == 0) ? temChangeUnit(Math.round(v.endTemp / 100)) : '--'
          v.avgTemp = (v.avgTemp || v.avgTemp == 0) ? temChangeUnit(Math.round(v.avgTemp / 100)) : '--'
          v.minVoltage = (v.minVoltage || v.minVoltage == 0) ? (v.minVoltage / 100).toFixed(2) + 'V' : '--'
          v.maxVoltage = (v.maxVoltage || v.maxVoltage == 0) ? (v.maxVoltage / 100).toFixed(2) + 'V' : '--'
          // switch (v.chargingType) {
          //   case 1:v.chargingTypeZh = i18n.t('yhubReport.FullCharge'); break// '满充'
          //   case 2:v.chargingTypeZh = i18n.t('yhubReport.Intermediate'); break// '临时充电'
          //   default:v.chargingTypeZh = '--'; break
          // }
          if (v.startTime && v.endTime) {
            var myTime = (new Date(v.endTime) - new Date(v.startTime))
            if (v.startTime) { v.startTimeRes = v.startTime; v.startTime = getDateAndHour(v.startTime, 'noYear') }
            if (v.endTime) { v.endTimeRes = v.endTime; v.endTime = getDateAndHour(v.endTime, 'noYear') }
            if ((v.startAh && v.endAh) || v.startAh == 0 || v.endAh == 0)v.energy = handleFloat(v.endAh - v.startAh)
            // v.chargedTime = parseInt((myTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((myTime % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
            v.chargedTime = usedTime(myTime, 'noSecond')
          }
          // if(v.chargedTime)v.chargedTime=updateTime()
        }
        this.getFullChargeStatu()// 判断充放电记录表格中的满充和临时充电
        // 动态合并单元格
        var cyclesIds = []
        this.chargedRecordsList.forEach((v, i) => {
          if (v.cycles)cyclesIds.push(v.cycles)
          v.num = 1
        })
        this.chargedRecordsList.forEach((v, i) => {
          if (!v.cycles) { // 如果最后的数据未形成一个循环，则后台不返回cycles，前端自定义为前一个cycles+1
            if (cyclesIds.length > 0) {
              v.cycles = cyclesIds[cyclesIds.length - 1] + 1
            } else {
              v.cycles = '--'
            }
          }
        })
        this.chargedRecordsList.forEach((v, i) => {
          if (i < this.chargedRecordsList.length - 1 && v.cycles == this.chargedRecordsList[i + 1].cycles) {
            v.num++
            this.chargedRecordsList[i + 1].num = v.num
          }
          if (v.isChargeing)v.chargeDisStatu = i18n.t('basicinfo.Charged')
          if (!v.isChargeing)v.chargeDisStatu = i18n.t('basicinfo.DisCharged')
        })

        // 处理一个循环里有多个充电时，最后两个充电的num正确，前面的不正确 eg:2 3 3
        for (var i = 0; i < this.chargedRecordsList.length; i++) {
          for (var j = i + 1; j < this.chargedRecordsList.length; j++) {
            if (this.chargedRecordsList[i].cycles == this.chargedRecordsList[j].cycles) {
              this.chargedRecordsList[i].num = this.chargedRecordsList[j].num
            }
          }
        }

        // 放电柱状图
        myChart2.hideLoading()
        const data = response.resultModel
        if (!data || (data && data.length < 1)) { this.columnLineNoData = true } else { this.columnLineNoData = false }
        console.log('data-------------', data)
        for (const i in data) {
          var model = data[i]

          n.push(getDateAndHour(model.endTime, 'noYear'))
          socData.push(this.doubleToInt(model.endSoc))

          if (this.minSoc > model.endSoc) {
            this.minSoc = this.doubleToInt(model.endSoc)
          }
          // debugger
          if (model.isChargeing) {
            // this.dataSize++
            // var difference = parseFloat(model.endAh - model.startAh)
            // this.chargedAh = this.chargedAh + difference
            chargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })

            disChargeData.push('')
          } else {
            disChargeData.push({
              value: parseFloat(model.endAh - model.startAh).toFixed(2), symbolSize: 1, tooltip: {
                formatter: this.myFormat(model)
              }
            })
            chargeData.push('')
          }
        }

        var option2 = {
          tooltip: {
            trigger: 'axis',
            show: true,
            showDelay: 50,
            hideDelay: 50,
            transitionDuration: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            borderColor: '#f50',
            borderRadius: 10,
            borderWidth: 0,
            padding: 10,
            textStyle: {
              color: '#F9F7F7',
              decoration: 'none',
              fontFamily: 'Verdana, sans-serif',
              fontSize: 10,
              fontStyle: 'italic'
            }
            // formatter: function(params, ticket, callback) {
            //   var res = params[0].name
            //   for (var i = 0, l = params.length; i < l; i++) {
            //     res += '<br/>' + params[i].seriesName + ': ' + params[i].value
            //   }
            //   setTimeout(function() {
            //     callback(ticket, res)
            //   }, 10)
            //   return 'loading'
            // }
          },
          legend: {
            data: [i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged'), i18n.t('warningPage.SOC')], // ['CHARGED', 'DISCHARGED', 'SOC']
            itemGap: 60
          },
          dataZoom: [{
            type: 'slider',
            show: true,
            start: 10,
            end: 90,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 10,
            end: 90
          }

          ],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: n,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false,
                color: '#272456'
              },

              axisLabel: {
                formatter: '{value} Ah',
                color: '#59588D'
              }
            },
            {
              type: 'value',
              name: 'SOC',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          color: ['#7fb80e', '#009ad6', '#A9F5F2'],
          series: [

            {
              name: i18n.t('basicinfo.Charged'),
              type: 'bar',
              barWidth: 20,
              data: chargeData,
              interval: 20,
              tooltip: {
                trigger: 'item'
              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: [
                    '{a|{c}}'
                  ].join(''),
                  rich: {

                    a: {
                      color: '#7fb80e',
                      align: 'center'
                    }

                  }
                }
              }
            },
            {
              barGap: '-100%',
              name: i18n.t('basicinfo.DisCharged'),
              type: 'bar',
              barWidth: 20,
              interval: 20,
              data: disChargeData,
              tooltip: {
                trigger: 'item'

              },
              label: {
                normal: {
                  show: true,
                  position: ['-5', '-20'],
                  distance: 1,
                  formatter: [
                    '{a|{c}}'
                  ].join(''),
                  rich: {

                    a: {
                      color: '#009ad6',
                      align: 'center'
                    }

                  }
                }
              }
            },
            {
              name: i18n.t('warningPage.SOC'),
              type: 'line',
              yAxisIndex: 1,
              data: socData,
              itemStyle: { normal: { label: {
                formatter: [
                  '{a|{c}}'
                ].join(''),
                rich: {

                  a: {
                    color: '#0B3B39',
                    align: 'center',
                    testsize: 18
                  }

                },
                show: true,
                position: 'left' }}}
            }
          ]
        }
        // this.columnLineData.chargeData = chargeData
        // this.columnLineData.disChargeData = disChargeData
        // this.columnLineData.socData = socData
        // this.columnLineN = n
        // console.log(option2)
        if (option2 && typeof option2 === 'object') {
          myChart2.setOption(option2, true)
          // console.log('this.myPieChart=====================', myChart2)
          // myChart2.on('finished', function() { // 图表渲染完成后
          //   this.jlcgImgBase64 = myChart2.getDataURL()
          //   document.getElementById('chart2').style.display = 'none'
          //   document.getElementById('chart3').style.display = 'block'
          //   document.getElementById('chart3').setAttribute('src', this.jlcgImgBase64)
          // })
        }
      })
    },
    getFullChargeStatu() { // 判断充放电记录表格中的满充和临时充电
      var fullChargeTime = this.fullChargeTime || 30

      if (this.chargedRecordsList.length > 0) {
        this.chargedRecordsList.forEach(v => {
          if (v.startTimeRes && v.endTimeRes) {
            v.myTime = (v.endTimeRes - v.startTimeRes) / (1000 * 60)
          } else if (!v.startTimeRes && v.startTime && v.endTime) {
            v.myTime = (v.endTime - v.startTime) / (1000 * 60)
          } else {
            v.myTime = 0
          }
          if (!v.isChargeing) { // 放电
            v.chargingTypeZh = '--'
          } else if ((v.endSoc == '100%' || (typeof (v.endSoc) === 'number' && Math.round(v.endSoc) == 100)) && v.isChargeing && v.myTime >= fullChargeTime) {
            v.chargingTypeZh = i18n.t('yhubReport.FullCharge') // '满充'
          } else {
            v.chargingTypeZh = i18n.t('yhubReport.Intermediate')// '临时充电'
          }
        })
      }
    },
    readMore(item) { // 弹窗--折线图--显示
      this.loading = true
      if (item != null) {
        this.popStartDate = item.startTimeRes
        this.popEndDate = item.endTimeRes
      } else {
        this.popStartDate = this.listQueryTem.startDate
        this.popEndDate = this.listQueryTem.endDate
      }
      // if (this.lineChartData.d3.length == 0 && this.lineChartData.d4.length == 0 && this.lineChartData.d5.length == 0 && this.lineChartData.d6.length == 0 &&
      //   this.lineChartData.d7.length == 0 && this.lineChartData.d8.length == 0 && this.lineChartData.d9.length == 0) {
      this.queryLine()
      // }
      this.isShowPop = true
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
      }, 0)
    },
    closePop() { // 弹窗--折线图--关闭
      this.isShowPop = false
    },
    changeSearch() { // 弹窗--折线图--时间选择
      this.loading = true
      this.queryLine()
    },
    downLoadExcel() {
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.listQueryTem.sn,
        mcuId: this.$route.query.mcuId,
        startDate: this.popStartDate,
        endDate: this.popEndDate
      }
      var timeZ = new Date().getTimezoneOffset() / 60

      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // console.log(param)
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/canbus/bmsRecord/exportBMSDataCsv'
      url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&timeZone=' + paramTimeZ + '&showAll=' + this.showAll + '&tem=' + tem
      window.open(url, '_bank')
    },
    downLoadReportExcel() {
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.listQueryTem.sn,
        mcuId: this.$route.query.mcuId,
        startDate: this.popStartDate,
        endDate: this.popEndDate
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      var tem = this.$store.state.temType == 'hsd' ? 'F' : 'C'
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/getcsv?sn='
      // url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + this.listQuery.sn
      url += param.sn + '&startTime=' + param.startDate + '&endTime=' + param.endDate + '&timeZone=' + paramTimeZ + '&showAll=' + this.showAll + '&tem=' + tem
      window.open(url, '_bank')
    },
    downChargeDis() { // 下载充放电数据
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('yhubReport.index'),
          i18n.t('yhubReport.StartingTime'),
          i18n.t('yhubReport.StartSOC'),
          i18n.t('yhubReport.EndTime'),
          i18n.t('yhubReport.EndSOC'),
          i18n.t('yhubReport.ah'),
          'KWH',
          i18n.t('yhubReport.StartTemp'),
          i18n.t('yhubReport.EndTemp'),
          i18n.t('yhubReport.averageTemp'),
          i18n.t('yhubReport.MinVoltage'),
          i18n.t('yhubReport.MaxVoltage'),
          i18n.t('yhubReport.ChargType'),
          i18n.t('yhubReport.Duration'),
          i18n.t('AllDevices.Status')
        ]
        const filterVal = [
          'cycles',
          'startTime',
          'startSoc',
          'endTime',
          'endSoc',
          'energy',
          'wh',
          'startTemp',
          'endTemp',
          'avgTemp',
          'minVoltage',
          'maxVoltage',
          'chargingTypeZh',
          'chargedTime',
          'chargeDisStatu'
        ]
        const list = this.chargedRecordsList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'chargedRecords',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    queryLine() { // 弹窗--折线图--数据获取及画线
      // console.log(this.row)
      // if (this.selectDay.length > 0) {
      //   this.popStartDate = getDateAndHour(new Date(this.selectDay[0]).getTime())
      //   this.popEndDate = getDateAndHour(new Date(this.selectDay[1]).getTime())
      // } else {
      //   this.popStartDate = this.row.startTime
      //   this.popEndDate = this.row.endTime
      // }
      var params = {
        // sn: this.popSn,
        startDate: this.popStartDate,
        endDate: this.popEndDate,
        mcuId: this.listQueryTem.mcuId
      }
      listBMSRecor(params).then(res => { // 弹窗折线图数据
        this.loading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        // if (!gnssProto.bmsRecord || (gnssProto.bmsRecord && gnssProto.bmsRecord.length < 1)) { this.nodata = true } else { this.nodata = false }
        if (gnssProto.bmsRecord != null && gnssProto.bmsRecord.bmsRecord != null) {
          const dataList = gnssProto.bmsRecord ? gnssProto.bmsRecord.bmsRecord : []
          this.nodata = !(dataList.length > 0)
          for (const i in this.lineChartData) {
            this.lineChartData[i] = []
          }
          console.log('dataList----', dataList)
          // ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)']
          for (const i in dataList) {
            var data = dataList[i]
            var time = data.yhubTime
            var cur = data.current
            var vol = data.batteryVoltage
            var soc = data.soc > 100 ? Math.round(data.soc) : data.soc
            var temp1 = data.temperature ? data.temperature.split(',')[0] : 0
            var temp2 = data.temperature ? data.temperature.split(',')[1] : 0
            var usedah = data.usedAh
            var chargedah = data.chargingAh
            if (cur < 0) {
              this.lineChartData.d3.push([time, (cur * -1 / 100).toFixed(2)])
              this.lineChartData.d4.push([time, (0 / 100).toFixed(2)])
            } else {
              this.lineChartData.d3.push([time, (0 / 100).toFixed(2)])
              this.lineChartData.d4.push([time, (cur / 100).toFixed(2)])
            }
            this.lineChartData.sn = this.listQueryTem.sn
            this.lineChartData.d5.push([time, (vol / 100).toFixed(2)])
            this.lineChartData.d6.push([time, (chargedah / 100).toFixed(2)])
            this.lineChartData.d7.push([time, (usedah / 100).toFixed(2)])
            this.lineChartData.d8.push([time, (soc / 100).toFixed(0)])
            this.lineChartData.d9.push([time, temChange(temp1)])
            this.lineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
            this.lineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          }
        }
      })
    },

    toCalculateChargeDischarge() {
      var param = {
        startDate: this.listQueryTem.startDate,
        endDate: this.listQueryTem.endDate,
        mcuId: this.listQueryTem.mcuId
      }
      if (param.endDate - param.startDate > 60 * 24 * 60 * 60 * 1000 - 1000) {
        this.$message({
          type: 'error',
          message: i18n.t('yhubReport.calculateChargeDischargeExceeded') // 每次最多计算60天内的充放电报表
        })
        return
      }
      this.$confirm(i18n.t('yhubReport.confirmCalculateChargeDischarge'), '', {
        // 是否确定重新计算充放电？
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        calculateChargeDischargeBms(param).then((res) => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted') // 重算充放电成功
            })
            this.initChart2()
          }
        })
      }).catch(() => {})
    },

    doubleToInt: function(d) {
      if (d !== null) {
        return Math.round(d)
      } else {
        return 0
      }
    },
    myFormat(params) {
      var str = ''
      const ah = thousandFn(parseFloat(params.endAh - params.startAh).toFixed(2)) || 0
      if (params.isChargeing) {
        str = '<h2>' + i18n.t('yhubReport.ChargedInfo') + '</h2>' +
            i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
            '<br/>' + i18n.t('yhubReport.StartingTime') + ':\t' + getDateAndHour(params.startTime, 'noYear') + '\t\t' + parseFloat(params.startSoc).toFixed(0) + '\t %' +
            '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t %' +
            '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
            '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
            '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
            '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      } else {
        str = '<h2>' + i18n.t('yhubReport.DischargedInfo') + '</h2>' +
            i18n.t('yhubReport.TotalAh') + ':\t' + ah + '\tAh' +
            '<br/>' + i18n.t('yhubReport.DepthDischarge') + ':\t' + parseFloat(100 - params.endSoc).toFixed(0) + '\t%' +
            '<br/>' + i18n.t('yhubReport.EndTime') + ':\t' + getDateAndHour(params.endTime, 'noYear') + '\t\t' + parseFloat(params.endSoc).toFixed(0) + '\t%' +
            '<br/>' + i18n.t('yhubReport.MinTemp') + ':\t' + temChange(parseFloat(params.minTemp / 100).toFixed(0)) + '\t' + temUnit() +
            '<br/>' + i18n.t('yhubReport.MaxTemp') + ':\t' + temChange(parseFloat(params.maxTemp / 100).toFixed(0)) + '\t' + temUnit() +
            '<br/>' + i18n.t('yhubReport.MinVoltage') + ':\t' + params.minVoltage / 100 + '\tV' +
            '<br/>' + i18n.t('yhubReport.MaxVoltage') + ':\t' + params.maxVoltage / 100 + '\tV'
      }
      return str
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      var myRowspan = 0
      if (columnIndex === 0) {
        // console.log('this.chargedRecordsList------', row, '+', row.num)
        if (rowIndex > 0 && this.chargedRecordsList[rowIndex - 1].cycles == this.chargedRecordsList[rowIndex].cycles) {
          myRowspan = 0
        } else {
          myRowspan = row.num
        }
        return {
          rowspan: myRowspan,
          colspan: 1
        }
      }
      // console.log('this.chargedRecordsList------', this.chargedRecordsList)
    },
    mouseoverQuestion(index, key) {
      if (key && key == 'dischargePop')document.querySelectorAll('.dischargePop')[index].style.display = 'block'
    },
    mouseoutQuestion(index, key) {
      if (key && key == 'dischargePop')document.querySelectorAll('.dischargePop')[index].style.display = 'none'
    },
    openCountSohPop(item) { // 弹窗--手动计算soh--显示
      console.log('item', item)
      this.isShowCountSOHPop = true
      this.sohSearchObj.sohStartTime = item.startTimeRes
      this.sohSearchObj.sohEndTime = item.endTimeRes
      var star = new Date(this.sohSearchObj.sohStartTime).getTime()
      var end = new Date(this.sohSearchObj.sohEndTime).getTime()
      this.querySoh(star, end)
      // this.computedSoh()
    },
    computedSoh() { // 手动计算soh
      var param = {
        'startDate': new Date(this.sohSearchObj.sohStartTime).getTime(),
        'endDate': new Date(this.sohSearchObj.sohEndTime).getTime(),
        'mcuId': this.listQueryTem.mcuId,
        'ignoreCharge': this.sohSearchObj.ignoreCharge,
        'updateData': this.sohSearchObj.updateData
      }
      this.loadingSoh = true
      // 因为一条充放电记录数据起止时间可能大于3天，所以暂时去掉3天限制
      // if (param.endDate - param.startDate > 24 * 60 * 60 * 1000 * 3) {
      //   this.$message({
      //     type: 'warning',
      //     message: '起止时间不能太大，必须控制在3天内'// i18n.t('allDeviceDetail.DeviceNameCannotEmpty')
      //   })
      //   return
      // }
      countSoh(param).then(res => {
        this.loadingSoh = false
        if (res.resultCode == 1001) {
          if (!res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.noEligibleData')// '计算成功,但本次计算无符合条件的数据！'
            })
          }
          if (res.resultModel) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.calcSuccess')// '计算成功！'
            })
            var star = new Date(this.sohSearchObj.sohStartTime).getTime()
            var end = new Date(this.sohSearchObj.sohEndTime).getTime()
            this.querySoh(star, end)
          }
        }
      })
    },
    querySoh(star, end) {
      var param = {
        startTime: '',
        endTime: '',
        mcuId: this.listQueryTem.mcuId
      }
      if (star) {
        param.startTime = star
        param.endTime = end
      }
      listSohRecord(param).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.sohData = res.resultModel
        this.sohData.forEach(v => {
          for (var attr in v) {
            if (attr == 'current_capacity' || attr == 'socVolt' || attr == 'soc_ll' || attr == 'soc_ph' || attr == 'soc_wph' || attr == 'soc_zt' || attr == 'soh_avg' || attr == 'theoretical_capacity') {
              v[attr] = Math.round(v[attr])
            }
            v.start_timeZh = getDateAndHour(v.start_time)
            v.end_timeZh = getDateAndHour(v.end_time)
          }
        })
      })
    }

  }
}
</script>

<style lang="scss">
*{
  // padding:0;
  margin:0;
  font-family: '微软雅黑';
}
p{
  margin:0
}
.lithiumChartChargeDisTem{
  height: 100%;
  background: #fff;
  padding: 10px;
  // position: relative;
  .el-dialog{
    margin-top: 10vh!important;
  }
}
.dischargePop{
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  width: auto;
  left: 50%;
  top: 25px;
  transform: translate(-50%, 0);
}
.columnLineWarp{
    .el-icon-question{
      top: 3px;
      position: absolute;
      left: calc(50% + 60px);
    }
    .en,.de{
      left: calc(50% + 60px);
    }
    .kl,.zh,.ft{
      left: calc(50% + 30px);
    }
    .ja{
      left: calc(50% + 50px);
    }
}
.chargedRecordTable{
  tr th:nth-last-child(1),tr td:nth-last-child(1){
    border-left: 1px solid #dfe6ec;
  }
  tbody tr:nth-of-type(1) td:nth-last-child(1){
    border-top: 1px solid #dfe6ec;
  }
}
</style>

